import React from 'react';
import Currency from '@prisjakt/ui-currency';

import { priceLabelStylingType, priceLabel } from './types';

import * as S from './styles';

type OwnProps = {
  className?: string;
  value: number | string | React.ReactNode;
  bold?: boolean;
  styling?: priceLabelStylingType;
  campaignStyling?: { background: string; text: string; name: string } | null;
};

type Props = OwnProps;

const PriceLabel = ({
  className,
  value,
  bold = true,
  styling = priceLabel.PRIMARY,
  campaignStyling,
}: Props) => {
  return (
    <S.PriceLabel
      className={className}
      bold={bold}
      styling={styling}
      campaignStyling={campaignStyling}
    >
      {typeof value === 'number' ? <Currency price={value} /> : value}
    </S.PriceLabel>
  );
};

export default PriceLabel;
